<script>
import Layout from "@/router/layouts/store";
import { api } from "@/state/services";
import { VMoney } from "v-money";

export default {
  locales: {
    pt: {
      'Order': 'Pedido',
      'Payment Method': 'Forma de Pagamento',
      'Order Date': 'Data do Pedido',

      'Items': 'Itens',
      'Item': 'Item',
      'Price': 'Preço',
      'Qty': 'Qtd',
      'Value': 'Valor',
      'Status': 'Status',
      'Date': 'Data',
      'Total': 'Total',

      'Switch plans': 'Trocar de Plano',
      'Current choice': 'Escolha Atual',
      'Choose': 'Escolher',
      'Plan name': 'Nome do Plano',
      'Plans': 'Planos',

      'Awaiting payment': 'Aguardando pagamento',
      'Payment confirmed': 'Pagamento confirmado',

      'Address': 'Endereço',
      'Send exactly value to make payment': 'Envie exatamente o valor para efetuar o pagamento',

      'The order was not found.': 'O pedido não foi encontrado.',
      'No records found.': 'Nenhum registro encontrado.',

      'Points': 'Pontos',

      'Delivery Address': 'Endereço de Entrega',
      'Pickup Address': 'Endereço de Retirada',
      'Track Order': 'Rastrear pedido',
      'Payment Details': 'Detalhes do pagamento',
      'SUBTOTAL': 'SUBTOTAL',
      'SHIPPING': 'FRETE',
      'DISCOUNT': 'DESCONTO',
      'TOTAL': 'TOTAL',
      'Payment Methods': 'Formas de Pagamento',
      'Combine multiple payment methods! With credit card pay at least 20% of the order in each transaction, or any amount below 20% when completing the payment of the rest of the order.': 'Combine múltiplas formas de pagamento! No cartão de crédito pague no mínimo 20% do pedido em cada transação, ou qualquer valor abaixo de 20% quando for complementar o pagamento do restante do pedido.',
      'Method': 'Forma',
      'Total paid:': 'Total pago:',
      'of': 'de',
      'Remaining:': 'Restante:',

      'Use the QR code to proceed with the transaction.': 'Use o código QR para prosseguir com a transação.',
      'Or use Pix Copy and Paste to proceed with the transaction.': 'Ou utilize o Pix Copia e Cola para prosseguir com a transação.',
      'Use Pix Copy and Paste to proceed with the transaction.': 'Use o Pix Copia e Cola para prosseguir com a transação.',
      'Copy Pix Copy and Paste': 'Copiar Pix Copia e Cola',
      'Copied to clipboard.': 'Copiado para a área de transferência.',
      'Now, all you need to do is access your bank app and complete the process using Pix Copy and Paste.': 'Agora, tudo o que você precisa fazer é acessar o aplicativo do seu banco e concluir o processo usando o Pix Copia e Cola.',
      'Amount to pay': 'Valor a pagar',
      'max:': 'máx:',
      'min:': 'mín:',
      'Generate Pix': 'Gerar Pix',
      'History': 'Histórico',
      'View': 'Ver',
      'View QR Code and Pix Copy and Paste': 'Ver QR Code e Pix Copia e Cola',

      'This order has reached the limit of 5 cards.': 'Este pedido já atingiu o limite de 5 cartões.',
      'Continue': 'Continuar',
      'Confirmed amount:': 'Valor confirmado:',
      'Whose card is it?': 'De quem é o cartão?',
      'Mine': 'Meu',
      "Someone else's": 'De outra pessoa',
      'Full cardholder name': 'Nome completo do titular',
      "Cardholder's CPF": 'CPF do titular',
      'Back': 'Voltar',
      'Number of Installments': 'Número de Parcelas',
      'Card Number': 'Número do Cartão',
      'Cardholder Name': 'Nome do Titular',
      'Expiration': 'Vencimento',
      'Month': 'Mês',
      'Year': 'Ano',
      'Security Code': 'Código de Segurança',
      'Pay': 'Pagar',

      'Account Balance': 'Saldo em Conta',
      'Your current balance is': 'Seu saldo atual é de',
      'and your balance after payment will be': 'e seu saldo após o pagamento será de',
      'Confirm': 'Confirmar',
      'You currently do not have enough balance to pay for this order.': 'No momento você não possui saldo suficiente para realizar o pagamento do pedido.',

      'Please wait!': 'Aguarde!',
      'We are processing your payment!': 'Estamos processando o seu pagamento!',

      'Pending': 'Pendente',
      'Expired': 'Expirado',
      'Canceled': 'Cancelado',
      'Paid': 'Pago',
      'Approved': 'Aprovado',
      'Under Review': 'Em análise',
      'Declined': 'Recusado',

      'The payment was made successfully.': 'O pagamento foi realizado com sucesso.',
      'An error occurred while processing the payment, please try again.': 'Ocorreu um erro ao processar o pagamento, tente novamente.',
      'Unable to generate the pix, please try again.': 'Não foi possível gerar o pix, tente novamente.',
      'An error occurred, please try again.': 'Ocorreu um erro, tente novamente.',
      'The order was paid successfully.': 'O pedido foi pago com sucesso.',
      'This order is not available for payment or already paid.': 'Este pedido não está disponível para pagamento ou já foi pago.',
      'You have no balance to pay for this order.': 'Você não possui saldo para pagar este pedido.',
      'Your payment was approved.': 'Seu pagamento foi aprovado.',
      'The amount entered is invalid.': 'O valor informado é inválido.',
      'The minimum amount per card is %amount%.': 'O valor mínimo por cartão é %amount%.',
      'Enter the full name and CPF of the cardholder.': 'Informe o nome completo e o CPF do titular do cartão.',
      'Unable to validate the cardholder.': 'Não foi possível validar o titular do cartão.',
      'The user was not found.': 'O usuário não foi encontrado.',
      'Unable to create the customer.': 'Não foi possível criar o cliente.',
      'The amount entered is no longer valid for this order.': 'O valor informado não é mais válido para este pedido.',
      'The payment was approved, but an error occurred while recording it. Please contact support.': 'O pagamento foi aprovado, mas ocorreu um erro ao registrá-lo. Entre em contato com o suporte.',
      'Please fill in all fields.': 'Por favor, preencha todos os campos.',
    },
    es: {
      'Order': 'Pedido',
      'Payment Method': 'Forma de Pago',
      'Order Date': 'Fecha del Pedido',

      'Items': 'Artículos',
      'Item': 'Artículo',
      'Price': 'Precio',
      'Qty': 'Cant.',
      'Value': 'Valor',
      'Status': 'Estado',
      'Date': 'Fecha',
      'Total': 'Total',

      'Switch plans': 'Cambiar de Plan',
      'Current choice': 'Elección Actual',
      'Choose': 'Elegir',
      'Plan name': 'Nombre del Plan',
      'Plans': 'Planes',

      'Awaiting payment': 'En espera de pago',
      'Payment confirmed': 'Pago confirmado',

      'Address': 'Dirección',
      'Send exactly value to make payment': 'Envía exactamente el monto para realizar el pago',

      'The order was not found.': 'El pedido no fue encontrado.',
      'No records found.': 'No se encontraron registros.',

      'Points': 'Puntos',

      'Delivery Address': 'Dirección de Entrega',
      'Pickup Address': 'Dirección de Retiro',
      'Track Order': 'Rastrear pedido',
      'Payment Details': 'Detalles del pago',
      'SUBTOTAL': 'SUBTOTAL',
      'SHIPPING': 'ENVÍO',
      'DISCOUNT': 'DESCUENTO',
      'TOTAL': 'TOTAL',
      'Payment Methods': 'Formas de Pago',
      'Combine multiple payment methods! With credit card pay at least 20% of the order in each transaction, or any amount below 20% when completing the payment of the rest of the order.': '¡Combina múltiples formas de pago! Con tarjeta de crédito paga al menos el 20% del pedido en cada transacción, o cualquier monto por debajo del 20% al completar el pago del resto del pedido.',
      'Method': 'Método',
      'Total paid:': 'Total pagado:',
      'of': 'de',
      'Remaining:': 'Restante:',

      'Use the QR code to proceed with the transaction.': 'Usa el código QR para continuar con la transacción.',
      'Or use Pix Copy and Paste to proceed with the transaction.': 'O usa Pix Copiar y Pegar para continuar con la transacción.',
      'Use Pix Copy and Paste to proceed with the transaction.': 'Usa Pix Copiar y Pegar para continuar con la transacción.',
      'Copy Pix Copy and Paste': 'Copiar Pix Copiar y Pegar',
      'Copied to clipboard.': 'Copiado al portapapeles.',
      'Now, all you need to do is access your bank app and complete the process using Pix Copy and Paste.': 'Ahora, todo lo que necesitas hacer es acceder a la app de tu banco y completar el proceso usando Pix Copiar y Pegar.',
      'Amount to pay': 'Monto a pagar',
      'max:': 'máx:',
      'min:': 'mín:',
      'Generate Pix': 'Generar Pix',
      'History': 'Historial',
      'View': 'Ver',
      'View QR Code and Pix Copy and Paste': 'Ver código QR y Pix Copiar y Pegar',

      'This order has reached the limit of 5 cards.': 'Este pedido ya alcanzó el límite de 5 tarjetas.',
      'Continue': 'Continuar',
      'Confirmed amount:': 'Monto confirmado:',
      'Whose card is it?': '¿De quién es la tarjeta?',
      'Mine': 'Mía',
      "Someone else's": 'De otra persona',
      'Full cardholder name': 'Nombre completo del titular',
      "Cardholder's CPF": 'CPF del titular',
      'Back': 'Volver',
      'Number of Installments': 'Número de Cuotas',
      'Card Number': 'Número de la Tarjeta',
      'Cardholder Name': 'Nombre del Titular',
      'Expiration': 'Vencimiento',
      'Month': 'Mes',
      'Year': 'Año',
      'Security Code': 'Código de Seguridad',
      'Pay': 'Pagar',

      'Account Balance': 'Saldo en Cuenta',
      'Your current balance is': 'Tu saldo actual es de',
      'and your balance after payment will be': 'y tu saldo después del pago será de',
      'Confirm': 'Confirmar',
      'You currently do not have enough balance to pay for this order.': 'Actualmente no tienes saldo suficiente para pagar este pedido.',

      'Please wait!': '¡Espera!',
      'We are processing your payment!': '¡Estamos procesando tu pago!',

      'Pending': 'Pendiente',
      'Expired': 'Expirado',
      'Canceled': 'Cancelado',
      'Paid': 'Pagado',
      'Approved': 'Aprobado',
      'Under Review': 'En revisión',
      'Declined': 'Rechazado',

      'The payment was made successfully.': 'El pago se realizó con éxito.',
      'An error occurred while processing the payment, please try again.': 'Ocurrió un error al procesar el pago, inténtalo de nuevo.',
      'Unable to generate the pix, please try again.': 'No fue posible generar el pix, inténtalo de nuevo.',
      'An error occurred, please try again.': 'Ocurrió un error, inténtalo de nuevo.',
      'The order was paid successfully.': 'El pedido se pagó con éxito.',
      'This order is not available for payment or already paid.': 'Este pedido no está disponible para pago o ya fue pagado.',
      'You have no balance to pay for this order.': 'No tienes saldo para pagar este pedido.',
      'Your payment was approved.': 'Tu pago fue aprobado.',
      'The amount entered is invalid.': 'El monto ingresado no es válido.',
      'The minimum amount per card is %amount%.': 'El monto mínimo por tarjeta es %amount%.',
      'Enter the full name and CPF of the cardholder.': 'Ingresa el nombre completo y el CPF del titular de la tarjeta.',
      'Unable to validate the cardholder.': 'No fue posible validar al titular de la tarjeta.',
      'The user was not found.': 'No se encontró el usuario.',
      'Unable to create the customer.': 'No fue posible crear el cliente.',
      'The amount entered is no longer valid for this order.': 'El monto ingresado ya no es válido para este pedido.',
      'The payment was approved, but an error occurred while recording it. Please contact support.': 'El pago fue aprobado, pero ocurrió un error al registrarlo. Ponte en contacto con soporte.',
      'Please fill in all fields.': 'Por favor, completa todos los campos.',
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      order: {
        id: this.$route.params.id,
        date: null,

        subtotal: '0.00',
        discount: '0.00',
        shipping: {
          method: '',
          value: '0.00',
          address: {
            zipcode: '',
            address: '',
            number: '',
            complement: '',
            district: '',
            city: '',
            state: '',
          }
        },
        payment: {
          methods: {},
          list: [],
          paid: '0.00',
          remaining: '0.00',
          history: {
            creditcard: [],
            pix: [],
          },
        },

        total: '0.00',

        items: null,
        status: null,

        points: {
          binary: 0,
          graduation: 0,
        }
      },

      balance: {
        loading: false,
        total: '0.00',
        valor: '0.00',
      },

      pix: {
        loading: false,
        valor: '0.00',
        text: '',
        image: '',
      },

      pixView: {
        modal: false,
        text: '',
        image: '',
      },

      creditcard: {
        step: 1,
        loading: false,
        modal: false,
        ip: '',
        valor: '0.00',
        titular: 'proprio',
        nome_completo: '',
        cpf: '',
        installments: [],
        installment: '1',
        number: '',
        expiryMonth: '',
        expiryYear: '',
        cvv: '',
        holderName: '',
      },

      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2
      },
    };
  },
  directives: { money: VMoney },
  computed: {
    progress() {
      var total = parseFloat(this.order.total || 0);
      if (total <= 0) {
        return 0;
      }
      return Math.min(100, (parseFloat(this.order.payment.paid || 0) / total) * 100);
    },
    creditcardMin() {
      var total     = parseFloat(this.order.total || 0);
      var remaining = parseFloat(this.order.payment.remaining || 0);
      var pct       = total * 0.2;
      return (remaining < pct) ? remaining : pct;
    },
    creditcardCount() {
      if (!this.order.payment.list || !this.order.payment.methods.creditcard) {
        return 0;
      }

      var name = this.order.payment.methods.creditcard.name;
      return this.order.payment.list.filter(function (item) {
        return item.name === name;
      }).length;
    },
    balanceAfter() {
      return parseFloat(this.balance.total || 0) - this.parseMoney(this.balance.valor);
    },
  },
  methods: {
    parseMoney(value) {
      if (!value) {
        return 0;
      }
      return parseFloat(String(value).replace(/[^\d,-]/g, '').replace(',', '.')) || 0;
    },
    getOrder() {
      if (this.order.id) {
        api
          .get('store/orders/' + this.order.id)
          .then(response => {
            if (response.data.status == 'success') {
              this.order = response.data.order

              this.pix.valor        = this.$options.filters.currency(this.order.payment.remaining);
              this.creditcard.valor = this.$options.filters.currency(this.order.payment.remaining);
              this.balance.valor    = this.$options.filters.currency(this.order.payment.remaining);
              this.creditcard.step  = 1;
              this.pix.text         = '';
              this.pix.image        = '';

              this.getBalance();
            }
          })
          .catch(error => {
            if (error) {
              this.$route.push("/store/orders")
            }
          })
      }
    },
    getBalance() {
      api
        .get('wallet/balance/network')
        .then(response => {
          if (response.data.status == 'success') {
            this.balance.total = response.data.balance;
          }
        })
    },
    payBalance() {
      this.balance.loading = true;

      api
        .post('wallet/pay/' + this.order.id, {
          valor: this.balance.valor,
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.$toast.success(this.t('The payment was made successfully.'))
            this.getOrder();
          } else {
            this.$toast.error(this.t(response.data.message))
          }
        })
        .catch(error => {
          if (error) {
            this.$toast.error(this.t('An error occurred while processing the payment, please try again.'))
          }
        })
        .finally(() => {
          this.balance.loading = false;
        })
    },
    gerarPix() {
      this.pix.loading = true;

      api
        .post('store/orders/' + this.order.id + '/pix', {
          valor: this.pix.valor,
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.pix.text  = response.data.pix.text;
            this.pix.image = response.data.pix.image;
          } else {
            this.$toast.error(this.t(response.data.message))
          }
        })
        .catch(error => {
          if (error) {
            this.$toast.error(this.t('Unable to generate the pix, please try again.'))
          }
        })
        .finally(() => {
          this.pix.loading = false;
        })
    },
    creditCardVoltar() {
      this.creditcard.step = this.creditcard.step - 1;
    },
    creditCardEscolherTitular() {
      this.creditcard.step = 2;
    },
    creditCardConfirmarTitular() {
      this.creditcard.loading = true;

      api
        .post('store/orders/' + this.order.id + '/creditcard/installments', {
          valor: this.creditcard.valor,
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.creditcard.installments = response.data.installments;
            this.creditcard.step = 3;
          } else {
            let message = this.t(response.data.message)
            if (response.data.amount) message = message.replace('%amount%', response.data.amount)

            this.$toast.error(message)
          }
        })
        .catch(error => {
          if (error) {
            this.$toast.error(this.t('An error occurred, please try again.'))
          }
        })
        .finally(() => {
          this.creditcard.loading = false;
        })
    },
    payCreditCard() {
      this.creditcard.loading = true;
      this.creditcard.modal = true;

      api
        .post('store/orders/' + this.order.id + '/creditcard', {
          valor: this.creditcard.valor,
          titular: this.creditcard.titular,
          nome_completo: this.creditcard.nome_completo,
          cpf: this.creditcard.cpf,
          installment: this.creditcard.installment,
          number: this.creditcard.number,
          holderName: this.creditcard.holderName,
          expiryMonth: this.creditcard.expiryMonth,
          expiryYear: this.creditcard.expiryYear,
          cvv: this.creditcard.cvv,
          ip: this.creditcard.ip,
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.$toast.success(this.t('The order was paid successfully.'))

            this.creditcard.loading = false;
            this.creditcard.modal = false;
            this.creditcard.step = 1;
            this.getOrder();
          } else {
            this.creditcard.loading = false;
            this.creditcard.modal = false;

            let message = this.t(response.data.message)
            if (response.data.amount) message = message.replace('%amount%', response.data.amount)

            this.$toast.error(message)
          }
        })
        .catch(error => {
          if (error) {
            this.creditcard.loading = false;
            this.creditcard.modal = false;
            this.$toast.error(this.t('An error occurred while processing the payment, please try again.'))
          }
        })
        .finally(() => {
          this.creditcard.loading = false;
          this.creditcard.modal = false;
        })
    },
    verPix(row) {
      this.pixView.text  = row.text;
      this.pixView.image = row.image;
      this.pixView.modal = true;
    },
    pixStatusLabel(status) {
      var labels = {
        pending: this.t('Pending'),
        expired: this.t('Expired'),
        canceled: this.t('Canceled'),
        approved: this.t('Paid'),
      };
      return labels[status] || status;
    },
    cardStatusLabel(status) {
      var labels = {
        RECEIVED: this.t('Approved'),
        CONFIRMED: this.t('Approved'),
        PENDING: this.t('Pending'),
        AWAITING_RISK_ANALYSIS: this.t('Under Review'),
      };
      return labels[status] || this.t('Declined');
    },
    getIp() {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          if (data.ip) {
            this.creditcard.ip = data.ip;
          }
        });
    },
  },
  mounted() {
    this.getOrder()
    this.getIp()
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex justify-content-between">
          <h4 class="mb-0 font-size-18">{{ t('Order') }}</h4>
        </div>
      </div>
    </div>

    <div v-if="!order.items" class="text-center">
      <b-spinner class="align-middle" variant="default" role="status"></b-spinner>
    </div>

    <div v-else-if="order.items && order.items.length == 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          {{ t('No records found.') }}
        </div>
      </div>
    </div>

    <div v-else class="row">
      <div class="col-lg-10 mx-auto">
        <div class="card">
          <div class="card-body p-4">
            <div class="p-2">
              <div class="d-flex">
                <h4 class="mb-0 font-size-15 flex-fill">
                  #{{ order.id }}
                </h4>
                <h4 class="mb-0 font-size-15 flex-fill text-right">
                  {{ order.date }}
                </h4>
              </div>
              <hr />
              <div class="table-responsive">
                <table class="table table-nowrap">
                  <thead>
                    <tr>
                      <th class="border-0 text-uppercase">{{ t('Item') }}</th>
                      <th class="border-0 text-uppercase">{{ t('Price') }}</th>
                      <th class="border-0 text-uppercase">{{ t('Qty') }}</th>
                      <th class="border-0 text-uppercase">{{ t('Total') }}</th>
                      <th class="border-0 text-uppercase">PG</th>
                      <th class="border-0 text-uppercase">PV</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(td, index) in order.items" :key="index">
                      <td>{{ td.name }} </td>
                      <td>{{ td.price | currency }}</td>
                      <td>{{ td.quantity }}</td>
                      <td>{{ td.subtotal | currency }}</td>
                      <td>{{ td.graduation }}</td>
                      <td>{{ td.binary }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 class="font-size-16 mt-5 mb-3">{{ t('Points') }}</h3>
              <div class="row">
                <div class="col-6">
                  <fieldset class="m-0 py-2 text-center">
                    <p class="mb-0">PG</p>
                    <h4 class="mb-0">{{ order.points.graduation }}</h4>
                  </fieldset>
                </div>
                <div class="col-6">
                  <fieldset class="m-0 py-2 text-center">
                    <p class="mb-0">PV</p>
                    <h4 class="mb-0">{{ order.points.binary }}</h4>
                  </fieldset>
                </div>
              </div>

              <div class="row mt-5">
                <div class="col-lg-6 mb-4">
                  <div v-if="order.shipping.address.zipcode">
                    <h3 v-if="order.type == 'receive'" class="font-size-16 mb-3">{{ t('Delivery Address') }}</h3>
                    <h3 v-else class="font-size-16 mb-3">{{ t('Pickup Address') }}</h3>
                    {{ order.shipping.address.address }},
                    {{ order.shipping.address.number }},
                    <span v-if="order.shipping.address.complement">{{ order.shipping.address.complement }}, </span>
                    {{ order.shipping.address.district }}<br>
                    {{ order.shipping.address.city }}/{{ order.shipping.address.state }},
                    {{ order.shipping.address.zipcode }}
                  </div>
                  <a v-if="order.shipping.tracking && order.shipping.tracking.code" target="_blank" :href="order.shipping.tracking.url" class="btn btn-default btn-sm mt-1 p-2 align-middle">
                    <i class="bx bxs-truck font-size-17 text-white mr-1 align-top"></i>
                    {{ t('Track Order') }}
                  </a>
                </div>
                <div class="col-lg-6 mb-4">
                  <h3 class="font-size-16 mb-3">{{ t('Payment Details') }}</h3>
                  <div class="table-responsive">
                    <table class="table table-nowrap table-borderless">
                      <tbody>
                        <tr v-if="order.subtotal != order.total">
                          <td class="px-0 py-1">{{ t('SUBTOTAL') }}</td>
                          <td class="px-0 py-1 text-right">{{ order.subtotal | currency }}</td>
                        </tr>
                        <tr>
                          <td class="px-0 py-1">{{ t('SHIPPING') }} — {{ order.shipping.method }}</td>
                          <td class="px-0 py-1 text-right">+ {{ order.shipping.value | currency }}</td>
                        </tr>
                        <tr v-if="order.discount != '0.00'">
                          <td class="px-0 py-1">{{ t('DISCOUNT') }}</td>
                          <td class="px-0 py-1 text-right">- {{ order.discount | currency }}</td>
                        </tr>
                        <tr>
                          <td class="px-0 py-1 font-weight-bold">{{ t('TOTAL') }}</td>
                          <td class="px-0 py-1 font-weight-bold text-right">{{ order.total | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <h3 class="font-size-16 mb-2">{{ t('Status') }}</h3>
              <div v-for="(td, index) in order.status" :key="index">
                {{ td.date }} — {{ t(td.status) }}
              </div>

              <template v-if="order.payment.status === 'pending' || order.payment.status === 'approved' && order.payment.list.length > 0">
                <h3 class="font-size-16 mb-3 mt-5">{{ t('Payment Methods') }}</h3>
                <p class="mb-4" v-if="order.payment.status === 'pending'">{{ t('Combine multiple payment methods! With credit card pay at least 20% of the order in each transaction, or any amount below 20% when completing the payment of the rest of the order.') }}</p>
                <fieldset v-if="order.payment.list.length > 0" class="mb-3 pb-2">
                  <div class="table-responsive">
                    <table class="table table-nowrap">
                      <thead class="thead-light">
                        <tr>
                          <th>{{ t('Method') }}</th>
                          <th>{{ t('Value') }}</th>
                          <th>{{ t('Date') }}</th>
                        </tr>
                      </thead>
                      <tbody class="font-size-13">
                        <tr v-for="(pay, index) in order.payment.list" :key="index">
                          <td>{{ pay.name }}</td>
                          <td>{{ pay.value | currency }}</td>
                          <td>{{ pay.date }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </fieldset>
                <template v-if="order.payment.status === 'pending'">
                  <div class="d-flex justify-content-between">
                    <div>{{ t('Total paid:') }} <strong>{{ order.payment.paid | currency }}</strong> {{ t('of') }} <strong>{{ order.total | currency }}</strong></div>
                    <div v-if="order.payment.status === 'pending'">{{ t('Remaining:') }} <strong>{{ order.payment.remaining | currency }}</strong></div>
                  </div>
                  <b-progress :value="progress" max="100" class="mt-2 mb-4"></b-progress>
                </template>
              </template>

              <b-tabs v-if="order.payment.status === 'pending'" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
                <b-tab v-if="order.payment.methods.pix">
                  <template v-slot:title>{{ order.payment.methods.pix.name }}</template>

                  <div class="row justify-content-center mt-4">
                    <div class="col-md-8">
                      <div v-if="pix.text">
                        <div v-if="pix.image">
                          <div>
                            {{ t('Use the QR code to proceed with the transaction.') }}
                          </div>
                          <div class="my-4 d-flex justify-content-center">
                            <div class="border rounded p-3">
                              <img style="width: 180px" :src="'data:image/png;base64,' + pix.image" />
                            </div>
                          </div>
                          <div>
                            {{ t('Or use Pix Copy and Paste to proceed with the transaction.') }}
                          </div>
                        </div>
                        <div v-else>
                          {{ t('Use Pix Copy and Paste to proceed with the transaction.') }}
                        </div>
                        <div class="my-4">
                          <fieldset class="text-break py-3">{{ pix.text }}</fieldset>
                        </div>
                        <div>
                          <button class="btn btn-default btn-lg btn-block text-uppercase" v-clipboard:copy="pix.text"
                            v-on:click="$toast.success('<strong>' + t('Copied to clipboard.') + '</strong><br>' + t('Now, all you need to do is access your bank app and complete the process using Pix Copy and Paste.'))">
                            {{ t('Copy Pix Copy and Paste') }}
                          </button>
                        </div>
                      </div>
                      <div v-else>
                        <b-form-group :label="t('Amount to pay')" label-for="pix-valor">
                          <b-form-input id="pix-valor" v-model="pix.valor" v-money="money" type="text" inputmode="decimal"></b-form-input>
                          <small class="text-muted">{{ t('max:') }} {{ order.payment.remaining | currency }}</small>
                        </b-form-group>
                        <button class="btn btn-default btn-lg btn-block" :disabled="pix.loading" v-on:click="gerarPix()">
                          {{ t('Generate Pix') }}
                          <b-spinner v-if="pix.loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
                        </button>
                      </div>

                      <div v-if="order.payment.history.pix.length > 0" class="mt-5 text-left">
                        <h5 class="font-size-14">{{ t('History') }}</h5>
                        <div class="table-responsive">
                          <table class="table table-sm table-nowrap">
                            <thead class="thead-light">
                              <tr>
                                <th class="border-0 text-uppercase">{{ t('Value') }}</th>
                                <th class="border-0 text-uppercase">{{ t('Status') }}</th>
                                <th class="border-0 text-uppercase">{{ t('Date') }}</th>
                                <th class="border-0 text-uppercase"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, index) in order.payment.history.pix" :key="index">
                                <td class="align-middle">{{ row.value | currency }}</td>
                                <td class="align-middle">{{ pixStatusLabel(row.status) }}</td>
                                <td class="align-middle">{{ row.date }}</td>
                                <td class="text-right">
                                  <button v-if="row.status === 'pending'" class="btn btn-outline-default btn-sm text-uppercase px-2 py-1"
                                    v-on:click="verPix(row)" :title="t('View QR Code and Pix Copy and Paste')">
                                    {{ t('View') }}
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab v-if="order.payment.methods.creditcard">
                  <template v-slot:title>
                    {{ order.payment.methods.creditcard.name }}
                  </template>
                  <div v-if="creditcardCount >= 5" class="text-center py-3">
                    {{ t('This order has already reached the limit of 5 cards.') }}
                  </div>
                  <div v-else class="row justify-content-center mt-4">
                    <div class="col-md-8">
                      <div v-if="creditcard.step == 1">
                        <b-form-group :label="t('Amount to pay')" label-for="creditcard-valor">
                          <b-form-input id="creditcard-valor" v-model="creditcard.valor" v-money="money" type="text" inputmode="decimal"></b-form-input>
                          <small class="text-muted">{{ t('max:') }} {{ order.payment.remaining | currency }}, {{ t('min:') }} {{ creditcardMin | currency }}</small>
                        </b-form-group>
                        <button class="btn btn-default btn-lg btn-block" v-on:click="creditCardEscolherTitular()">
                          {{ t('Continue') }}
                        </button>
                      </div>

                      <div v-else-if="creditcard.step == 2">
                        <p>{{ t('Confirmed amount:') }} <strong>{{ creditcard.valor }}</strong></p>
                        <b-form-group :label="t('Whose card is it?')">
                          <b-form-radio-group v-model="creditcard.titular" :options="[{ text: t('Mine'), value: 'proprio' }, { text: t('Someone else\'s'), value: 'terceiro' }]"></b-form-radio-group>
                        </b-form-group>
                        <template v-if="creditcard.titular == 'terceiro'">
                          <b-form-group :label="t('Full cardholder name')" label-for="nome_completo">
                            <b-form-input id="nome_completo" v-model="creditcard.nome_completo" type="text" required></b-form-input>
                          </b-form-group>
                          <b-form-group :label="t('Cardholder\'s CPF')" label-for="cpf">
                            <b-form-input id="cpf" v-model="creditcard.cpf" type="text" required v-mask="'###.###.###-##'"></b-form-input>
                          </b-form-group>
                        </template>
                        <div>
                          <button class="btn btn-default btn-lg btn-block mb-2" :disabled="creditcard.loading" v-on:click="creditCardConfirmarTitular()">
                            {{ t('Continue') }}
                            <b-spinner v-if="creditcard.loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
                          </button>
                          <button class="btn btn-outline-dark btn-lg btn-block" v-on:click="creditCardVoltar()">{{ t('Back') }}</button>
                        </div>
                      </div>

                      <b-form v-else @submit.prevent="payCreditCard">
                        <b-form-group :label="t('Number of Installments')" label-for="creditcard.installment">
                          <b-form-select id="installment" v-model="creditcard.installment" :options="creditcard.installments" required></b-form-select>
                        </b-form-group>
                        <b-form-group :label="t('Card Number')" label-for="number">
                          <b-form-input id="number" v-model="creditcard.number" type="text" required v-mask="'#### #### #### ####'"></b-form-input>
                        </b-form-group>
                        <b-form-group :label="t('Cardholder Name')" label-for="holderName">
                          <b-form-input id="holderName" v-model="creditcard.holderName" type="text" required></b-form-input>
                        </b-form-group>
                        <div class="row">
                          <div class="col-12 col-md-6">
                            <b-form-group :label="t('Expiration')" label-for="expiryDate">
                              <b-input-group>
                                <b-form-input id="expiryMonth" v-model="creditcard.expiryMonth" type="text" :placeholder="t('Month')" maxlength="2" required v-mask="'##'"></b-form-input>
                                <b-form-input id="expiryYear" v-model="creditcard.expiryYear" type="text" :placeholder="t('Year')" maxlength="2" required v-mask="'##'"></b-form-input>
                              </b-input-group>
                            </b-form-group>
                          </div>
                          <div class="col-12 col-md-6">
                            <b-form-group :label="t('Security Code')" label-for="cvv">
                              <b-form-input id="cvv" v-model="creditcard.cvv" type="text" required v-mask="'###'"></b-form-input>
                            </b-form-group>
                          </div>
                        </div>
                        <div>
                          <button class="btn btn-default btn-lg btn-block" type="submit" :disabled="creditcard.loading">
                            {{ t('Pay') }}
                            <b-spinner v-if="creditcard.loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
                          </button>
                          <button class="btn btn-outline-dark btn-lg btn-block" type="button" v-on:click="creditCardVoltar()">{{ t('Back') }}</button>
                        </div>
                      </b-form>

                      <div v-if="order.payment.history.creditcard.length > 0" class="mt-5 text-left">
                        <h5 class="font-size-14">{{ t('History') }}</h5>
                        <div class="table-responsive">
                          <table class="table table-sm table-nowrap">
                            <thead>
                              <tr>
                                <th class="border-0 text-uppercase">{{ t('Value') }}</th>
                                <th class="border-0 text-uppercase">{{ t('Status') }}</th>
                                <th class="border-0 text-uppercase">{{ t('Date') }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, index) in order.payment.history.creditcard" :key="index">
                                <td>{{ row.value | currency }}</td>
                                <td>{{ cardStatusLabel(row.status) }}</td>
                                <td>{{ row.date }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab key="balance">
                  <template v-slot:title>{{ t('Account Balance') }}</template>
                  <div class="row justify-content-center mt-4">
                    <div class="col-md-8">
                      <template v-if="balance.total > 0">
                        <b-form-group :label="t('Amount to pay')" label-for="balance-valor">
                          <b-form-input id="balance-valor" v-model="balance.valor" v-money="money" type="text" inputmode="decimal"></b-form-input>
                        </b-form-group>
                        <p>{{ t('Your current balance is') }} <strong>{{ balance.total | currency }}</strong> {{ t('and your balance after payment will be') }} <strong>{{ balanceAfter | currency }}</strong>.</p>
                        <button class="btn btn-default btn-lg btn-block mr-3" :disabled="balance.loading || balanceAfter < 0" v-on:click="payBalance()">
                          {{ t('Confirm') }}
                          <b-spinner v-if="balance.loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
                        </button>
                      </template>
                      <template v-else>
                        <p>{{ t('You currently do not have enough balance to pay for this order.') }}</p>
                      </template>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="creditcard.modal" modal-class="modal-center" hide-header hide-footer centered no-close-on-backdrop no-close-on-esc>
      <div class="text-center py-4">
        <div class="d-flex justify-content-center align-items-center mb-4">
          <b-spinner large class="align-middle" variant="default" role="status"></b-spinner>
        </div>
        <h5>{{ t('Please wait!') }}</h5>
        <h6>{{ t('We are processing your payment!') }}</h6>
      </div>
    </b-modal>

    <b-modal v-model="pixView.modal" title="PIX" centered hide-footer>
      <div v-if="pixView.image" class="text-center">
        <div class="my-2 d-flex justify-content-center">
          <div class="border rounded p-3">
            <img style="width: 180px" :src="'data:image/png;base64,' + pixView.image" />
          </div>
        </div>
      </div>
      <div class="my-3">
        <fieldset class="text-break py-3">{{ pixView.text }}</fieldset>
      </div>
      <button class="btn btn-default btn-lg btn-block text-uppercase" v-clipboard:copy="pixView.text"
        v-on:click="$toast.success('<strong>' + t('Copied to clipboard.') + '</strong><br>' + t('Now, all you need to do is access your bank app and complete the process using Pix Copy and Paste.'))">
        {{ t('Copy Pix Copy and Paste') }}
      </button>
    </b-modal>
  </Layout>
</template>